import { createClient, type SupabaseClient } from '@supabase/supabase-js';

// The anon/publishable key is safe to ship to the browser — RLS gates every
// write (public read only; writes require an authenticated admin). VITE_SUPABASE_*
// override these, but the production project is the default so the deployed site
// works even when the build has no env vars set.
// `??` (not `||`) so an explicit empty env value disables the CMS (used by the
// test build for a deterministic static-seed render); `undefined` uses the fallback.
const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined)
  ?? 'https://gijfviayrxzppfgiwlko.supabase.co';
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)
  ?? 'sb_publishable_ZdoddI56pYmotBgnBapIjg_WBwvzFja';

export const supabaseEnabled = Boolean(url && anonKey);

// ponytail: single shared client; null only if the fallback is ever emptied.
export const supabase: SupabaseClient | null = supabaseEnabled
  ? createClient(url, anonKey)
  : null;
